import { createSlice } from '@reduxjs/toolkit';
import type { RirekishoContact } from '@src/api/core/api-types';
import type { RootState } from '@src/store';
import { createSimpleSliceReducers } from '../helpers/slice_helpers';

const initialState: RirekishoContact = {
  zipCode: '',
  contact: '',
  contactReading: '',
  areaCode: '',
  phoneNumber: '',
  callInfo: '',
};

const rirekishoContactSlice = createSlice({
  name: 'rirekishoContact',
  initialState,
  reducers: {
    ...createSimpleSliceReducers<RirekishoContact>(),
  },
});

export const { update: updateRirekishoContact } = rirekishoContactSlice.actions;

// Selectors
const _selectRirekishoContact = (state: RootState) => state.rirekisho.contact;

export default rirekishoContactSlice.reducer;
